module.exports = __webpack_public_path__ + "img/bg_pay@3x.979e54d6.png";